// removed by extract-text-webpack-plugin
module.exports = {"container":"DocumentsInfo-module-container-2Nvpn","title":"DocumentsInfo-module-title-1MygV","designation":"DocumentsInfo-module-designation-3c1EY","valeo-info":"DocumentsInfo-module-valeo-info-_NhLO","valeoInfo":"DocumentsInfo-module-valeo-info-_NhLO","date":"DocumentsInfo-module-date-1QfIv","valeo-id":"DocumentsInfo-module-valeo-id-2kwpy","valeoId":"DocumentsInfo-module-valeo-id-2kwpy","paragraphs-list":"DocumentsInfo-module-paragraphs-list-PHIUQ","paragraphsList":"DocumentsInfo-module-paragraphs-list-PHIUQ","paragraph":"DocumentsInfo-module-paragraph-ojG2i"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/TechnicalDocument/components/DocumentsInfo/DocumentsInfo.module.scss
// module id = 1320
// module chunks = 0